import type { ActionParams } from '@swf/components/StarsMPNotification/config/NotificationTypes';
import { dispatch } from '@swf/core/store';

import defaultHeaderImg from '../../assets/images/default-header.png';
import CardBackDefault from '../../components/CardBack/Default';
import DefaultView from '../../components/GameTicket/GameTicket';
import { ActionType, FormatType } from '../../enums';

import {
  TXTCLI_Close,
  TXTCLI_More_information,
  TXTWCL_DrawX,
  TXTWCL_Number_of_entriesX
} from './FixedPrizeDraw.Issued.messages.json';

export default {
  front: {
    view: DefaultView,
    viewConfig: {
      moreInfoLabel: { tag: TXTCLI_More_information },
      defaultHeaderImageURL: defaultHeaderImg,
      showCloseIcon: true,
      displayAttributes: [
        {
          attrKey: 'entries',
          attrLabel: { tag: TXTWCL_Number_of_entriesX },
          attrFormatterType: FormatType.Number
        },
        {
          attrKey: 'draw',
          attrLabel: { tag: TXTWCL_DrawX },
          attrFormatterType: FormatType.Date
        }
      ],
      actions: [
        {
          actionType: ActionType.Primary,
          actionLabel: { tag: TXTCLI_Close },
          actionFunction: ({ notificationId }: ActionParams) => {
            dispatch.notification.delete({ notificationId });
            dispatch.modal.close('/mpnotifications');
          }
        }
      ]
    }
  },
  back: {
    view: CardBackDefault,
    viewConfig: {
      title: { tag: TXTCLI_More_information }
    }
  }
};
